module.exports = __webpack_public_path__ + "img/7-en.a3b6d4dd.png";